// extracted by mini-css-extract-plugin
export default {"labelContainer":"styles-module__labelContainer__src-labstep-web-core-Form-Reusable-Label-_xkAGn"};